import React from 'react';
import { HidingTooltip } from 'ui/Tooltip/HidingTooltip';
import { formatDateWithoutOffset } from 'utils';
import ClockOutlineIcon from 'ui/Icons/clock-outline.component.svg';
import UserOutlineIcon from 'ui/Icons/user-outline.component.svg';
import { IUserInfo } from '../types';

interface IAuditInfoProps {
  createdAt: string;
  createdBy: IUserInfo;
  updatedAt: string;
  updatedBy: IUserInfo;
}

export const AuditInfo: React.FC<IAuditInfoProps> = ({ createdAt, createdBy, updatedAt, updatedBy }) => {
  const formatDateTime = (date: string) => formatDateWithoutOffset(date, 'd MMM yyyy, HH:mm');

  const renderUserName = (user: IUserInfo) => {
    const name = [user.firstName, user.lastName].filter(Boolean).join(' ');

    if (user.email) {
      return (
        <HidingTooltip
          position="bottom"
          renderTooltipContent={() => (
            <div className="p-10px">
              <span className="text-13px">{user.email}</span>
            </div>
          )}
        >
          <span className="cursor-pointer">{name}</span>
        </HidingTooltip>
      );
    }

    return <span>{name}</span>;
  };

  const renderRoleBadge = (user: IUserInfo) => (
    <span className="bg-gray-10 px-5px py-[2px] rounded-[1px] text-12px uppercase tracking-[0.04em] text-black">
      {user.type.toUpperCase()}
    </span>
  );

  return (
    <div className="flex flex-col gap-5px text-15px font-pt-sans text-gray-100">
      {/* Created row */}
      <div className="flex items-center justify-end gap-5px">
        <ClockOutlineIcon className="w-[18px] h-[18px] flex-shrink-0 fill-transparent stroke-current stroke-2" />
        <span className="w-[55px]">Created</span>
        <span>{formatDateTime(createdAt)}</span>
        <span className="text-gray-20">|</span>
        <UserOutlineIcon className="w-[18px] h-[18px] flex-shrink-0 fill-transparent stroke-current stroke-2" />
        {renderUserName(createdBy)}
        {renderRoleBadge(createdBy)}
      </div>

      {/* Updated row */}
      <div className="flex items-center justify-end gap-5px">
        <ClockOutlineIcon className="w-[18px] h-[18px] flex-shrink-0 fill-transparent stroke-current stroke-2" />
        <span className="w-[55px]">Updated</span>
        <span>{formatDateTime(updatedAt)}</span>
        <span className="text-gray-20">|</span>
        <UserOutlineIcon className="w-[18px] h-[18px] flex-shrink-0 fill-transparent stroke-current stroke-2" />
        {renderUserName(updatedBy)}
        {renderRoleBadge(updatedBy)}
      </div>
    </div>
  );
};
